import { render, staticRenderFns } from "./AllergiesSection.vue?vue&type=template&id=73bfe1b8"
import script from "./AllergiesSection.vue?vue&type=script&lang=ts"
export * from "./AllergiesSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73bfe1b8')) {
      api.createRecord('73bfe1b8', component.options)
    } else {
      api.reload('73bfe1b8', component.options)
    }
    module.hot.accept("./AllergiesSection.vue?vue&type=template&id=73bfe1b8", function () {
      api.rerender('73bfe1b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/components/AllergiesSection.vue"
export default component.exports